import React from 'react';
import RouteOutlet from '../Routes';

const Body = () => {
  return (
    <div className="app-body" id="app-body">
        <RouteOutlet />
    </div>
  );
};

export default Body;